<template>
  <div class="WorkPositionPage contentBox">
    <div class="leftContent">
      <p class="title">
        <span>岗位类别</span>
        <!-- <i class="el-icon-circle-plus-outline"></i> -->
      </p>
      <el-tree
        ref="WorkPositiontree"
        :data="positionTypeList"
        :props="defaultProps"
        @node-click="handleNodeClick"
        highlight-current
        node-key="id"
        :default-expanded-keys="[positionTypeId]"
        :current-node-key="positionTypeId"
      >
      </el-tree>
    </div>
    <div class="rightContent">
      <el-table
        stripe
        :data="positionData"
        border
        style="width: 100%"
        height="100%"
        size="mini"
        @sort-change="sortChange"
      >
        <el-table-column
          type="index"
          width="50"
          align="center"
          :index="pagination.beginIndex"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="岗位名称"
          align="center"
          sortable="custom"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="typeId"
          label="岗位类别"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.workPositionType">{{
              scope.row.workPositionType.name
            }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          class-name="operation"
          label="操作"
          align="center"
          width="95px"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="修改"
              placement="top"
              :open-delay="300"
            >
              <i @click="editPosition($event, scope.row)" class="el-icon-edit"></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="上移"
              placement="top"
              :open-delay="300"
              v-show="positionTypeId"
            >
              <i
                @click="moveUpPosition($event, scope.row)"
                class="el-icon-arrow-up"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="下移"
              placement="top"
              :open-delay="300"
              v-show="positionTypeId"
            >
              <i
                @click="moveDownPosition($event, scope.row)"
                class="el-icon-arrow-down"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="deletePosition($event, scope.row)"
                class="el-icon-delete"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pagination="pagination"
        @currentChange="currentChange"
        @sizeChange="sizeChange"
        @refreshBtn="getPositionSearch"
      ></pagination>
    </div>
    <myDialog
      ref="positionDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="岗位名称：" size="small" prop="name">
            <el-input
              v-model="dialogForm.name"
              placeholder="输入岗位名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="岗位类别："
            size="small"
            prop="typeId"
          >
            <el-select
              v-model="dialogForm.typeId"
              placeholder="选择岗位类别"
              clearable
            >
              <el-option
                v-for="item in pullDownData.positionTypeList"
                :key="item.value"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiPositionTypeList,
  apiPositionSearch,
  apiPositionAdd,
  apiPositionUpdate,
  apiPositionMoveUp,
  apiPositionMoveDown,
  apiPositionDelete,
} from "@/api/userApi.js";
export default {
  props: {
    positionSearchForm: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    pagination,
    myDialog,
  },
  data() {
    return {
      // tree配置
      defaultProps: {
        children: "children",
        label: "name",
      },
      positionTypeId: "",
      pullDownData: {
        positionTypeList: [],
      },
      positionTypeList: [],
      positionData: [],
      orderBy: [],
      desc: undefined,
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      dialogTitle: "",
      dialogForm: {},
      dialogRules: {
        name: [
          { required: true, message: "名称不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 32,
            message: "长度在 2 到 32 个字符",
            trigger: "change"
          }
        ],
        typeId: [
          { required: true, message: "岗位类别不能为空！", trigger: "change" },
        ],
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  methods: {
    // 岗位-岗位类别
    async getPositionTypeList(remove, callback) {
      if (remove != "noRemove") {
        this.positionTypeList = [];
      }
      const res = await apiPositionTypeList();
      // console.log(res);
      if (res.code == 0) {
        this.positionTypeList = JSON.parse(JSON.stringify(res.data));
        this.positionTypeList.unshift({
          id: "",
          name: "全部岗位",
        });
        this.pullDownData.positionTypeList = res.data;
        this.getPositionSearch();
        this.$nextTick(() => {
          this.$refs.WorkPositiontree.setCurrentKey(this.positionTypeId);
        });
        if (callback) callback();
      }
    },
    // 岗位-表格数据
    async getPositionSearch(remove) {
      if (!(remove == "noRemove")) {
        this.positionData = [];
      }
      const res = await apiPositionSearch({
        ...this.positionSearchForm,
        typeId: this.positionTypeId,
        orderBy: this.orderBy,
        desc: this.desc,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      });
      // console.log(res);
      if (res.code == 0) {
        this.positionData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
      }
    },
    // tree点击
    handleNodeClick(data) {
      // console.log(data);
      if (this.positionTypeId == data.id) return;
      this.positionTypeId = data.id;
      this.pagination.currentPage = 1;
      this.getPositionSearch();
    },
    // 添加岗位
    addPosition() {
      this.dialogTitle = "添加岗位";
      this.$refs.positionDialog.dialogVisible = true;
    },
    // 编辑岗位
    editPosition(e, row) {
      this.dialogTitle = "修改岗位";
      this.$refs.positionDialog.dialogVisible = true;
      this.dialogForm = {
        id: row.id,
        name: row.name,
        typeId: row.workPositionType.id,
      };
    },
    // 上移岗位
    moveUpPosition(e, row) {
      e.target.blur();
      this.$confirm(`是否上移【${row.name}】？`, "上移岗位", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiPositionMoveUp({
          id: row.id,
        });
        if (res.code == 0) {
          this.getPositionSearch("noRemove");
          this.$message({
            message: "上移成功",
            type: "success",
          });
        }
      });
    },
    // 下移岗位
    moveDownPosition(e, row) {
      e.target.blur();
      this.$confirm(`是否下移【${row.name}】？`, "下移岗位", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiPositionMoveDown({
          id: row.id,
        });
        if (res.code == 0) {
          this.getPositionSearch("noRemove");
          this.$message({
            message: "下移成功",
            type: "success",
          });
        }
      });
    },
    // 删除岗位
    deletePosition(e, row) {
      e.target.blur();
      this.$allOperation(row, "删除", "岗位").then(async () => {
        const res = await apiPositionDelete({
          id: row.id,
        });
        if (res.code == 0) {
          this.getPositionSearch("noRemove");
          this.$message({
            message: "删除成功",
            type: "success",
          });
        }
      });
    },
    // 确认添加
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          if (title == "添加岗位") {
            const res = await apiPositionAdd({
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.positionDialog.dialogVisible = false;
              this.pagination.currentPage = 1;
              this.getPositionSearch();
              this.$message({
                message: "新建成功",
                type: "success",
              });
            }
          } else if (title == "修改岗位") {
            const res = await apiPositionUpdate({
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.positionDialog.dialogVisible = false;
              this.getPositionSearch("noRemove");
              this.$message({
                message: "修改成功",
                type: "success",
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getPositionSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getPositionSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getPositionSearch();
    },
  },
};
</script>

<style lang="less" scoped>
</style>